'use client'

import React from 'react'

export interface FooterTransitionProps {
  className?: string
}

export const FooterTransition: React.FC<FooterTransitionProps> = ({ className = '' }) => {
  return (
    <div className={`pointer-events-none relative ${className}`}>
      {/* Gradual darkening transition */}
      <div
        className="w-full h-64"
        style={{
          background: `linear-gradient(to bottom, 
            transparent 0%, 
            rgba(0,0,0,0.1) 20%, 
            rgba(0,0,0,0.3) 40%, 
            rgba(0,0,0,0.5) 60%, 
            rgba(0,0,0,0.7) 80%, 
            rgba(0,0,0,0.9) 100%
          )`,
        }}
      />
    </div>
  )
}
